export default "__VITE_ASSET__DGDkZjqo__"